 function getUrlStr(name){
        let reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
        if (reg.test(window.location.href)) {
          return unescape(RegExp.$2.replace(/\+/g, " "))
        }
      return undefined
 };
 function toggleBody(isPin){
  if(isPin){
    document.body.style.height = '100vh';
    document.body.style['overflow-y'] = 'hidden';
  }
  else{
    document.body.style.height = 'unset';
    document.body.style['overflow-y'] = 'auto';
  }
}

export {getUrlStr,toggleBody}






//////////////////
// WEBPACK FOOTER
// ./static/js/Subparameter.js
// module id = fseO
// module chunks = 1